import { render, staticRenderFns } from "./QLeadSalesReceiptSummaryDataTable.vue?vue&type=template&id=f843f2ba&scoped=true&"
import script from "./QLeadSalesReceiptSummaryDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadSalesReceiptSummaryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadSalesReceiptSummaryDataTable.vue?vue&type=style&index=0&id=f843f2ba&prod&scoped=true&lang=css&"
import style1 from "./QLeadSalesReceiptSummaryDataTable.vue?vue&type=style&index=1&id=f843f2ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f843f2ba",
  null
  
)

export default component.exports